import React, { useCallback, useState, } from "react";
import { updateProfile } from "@ludens-reklame/rubics-v3-sdk/profile";
// {} as IStoreContext is a hack, as it actually is not necessary to provide default values here
export const ProfileContext = React.createContext({});
export const ProfileContextProvider = ({ initialProfile, children }) => {
    const [_profile, setProfile] = useState(initialProfile || null);
    const [networking, setNetworking] = useState(false);
    const update = useCallback(async (profile) => {
        setNetworking(true);
        const newProfile = await updateProfile(profile);
        setProfile(newProfile);
        setNetworking(false);
    }, []);
    return (React.createElement(ProfileContext.Provider, { value: {
            profile: _profile,
            networking,
            update,
        } }, children));
};
